module.exports = __webpack_public_path__ + "static/media/step-indicator-3.513baa9d.svg";